/* MUZZARA — vanilla scripts, no dependencies */
(function () {
  'use strict';

  var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function initReveals() {
    var els = document.querySelectorAll('.mz-reveal');
    if (!els.length) return;
    if (reduceMotion || !('IntersectionObserver' in window)) {
      els.forEach(function (el) { el.classList.add('mz-visible'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('mz-visible');
          io.unobserve(entry.target);
        }
      });
    }, { threshold: 0.01, rootMargin: '0px 0px 0px 0px' });
    els.forEach(function (el) { io.observe(el); });

    function forceRevealAll() {
      document.querySelectorAll('.mz-reveal:not(.mz-visible)').forEach(function (el) {
        el.classList.add('mz-visible');
      });
    }
    setTimeout(forceRevealAll, 1200);
    window.addEventListener('hashchange', function () { setTimeout(forceRevealAll, 50); });
    if (window.location.hash) setTimeout(forceRevealAll, 50);
  }

  function initFinder() {
    document.querySelectorAll('[data-mz-finder]').forEach(function (finder) {
      var question = finder.querySelector('[data-mz-finder-question]');
      var options = finder.querySelectorAll('[data-mz-finder-option]');
      var results = finder.querySelectorAll('[data-mz-finder-result]');

      function showResult(targetId) {
        results.forEach(function (r) { r.classList.toggle('is-active', r.id === targetId); });
        if (question) question.classList.add('is-hidden');
        var active = finder.querySelector('#' + targetId);
        if (active) {
          active.setAttribute('tabindex', '-1');
          active.focus({ preventScroll: true });
        }
      }

      function reset() {
        results.forEach(function (r) { r.classList.remove('is-active'); });
        if (question) question.classList.remove('is-hidden');
      }

      options.forEach(function (opt) {
        opt.addEventListener('click', function () {
          showResult(opt.getAttribute('data-target'));
        });
      });
      finder.querySelectorAll('[data-mz-finder-back]').forEach(function (btn) {
        btn.addEventListener('click', reset);
      });
    });
  }

  function initReviewForm() {
    document.querySelectorAll('[data-mz-reviews]').forEach(function (block) {
      var toggle = block.querySelector('[data-mz-review-toggle]');
      var form = block.querySelector('[data-mz-review-form]');
      if (!toggle || !form) return;

      var hasSuccess = form.querySelector('.mz-review-form__success');
      if (hasSuccess) form.hidden = false;

      toggle.addEventListener('click', function () {
        form.hidden = !form.hidden;
        if (!form.hidden) {
          var firstField = form.querySelector('input, textarea');
          if (firstField) firstField.focus();
        }
      });

      var stars = form.querySelectorAll('[data-mz-star-input] .mz-review-form__star');
      function updateStars() {
        var checkedIndex = -1;
        stars.forEach(function (star, i) {
          if (star.querySelector('input').checked) checkedIndex = i;
        });
        stars.forEach(function (star, i) {
          star.classList.toggle('is-filled', i <= checkedIndex);
        });
      }
      stars.forEach(function (star) {
        star.querySelector('input').addEventListener('change', updateStars);
      });
      updateStars();
    });
  }

  function initFaqSingleOpen() {
    var groups = document.querySelectorAll('[data-mz-faq]');
    groups.forEach(function (group) {
      var items = group.querySelectorAll('.mz-faq__item');
      items.forEach(function (item) {
        item.addEventListener('toggle', function () {
          if (!item.open) return;
          items.forEach(function (other) {
            if (other !== item) other.open = false;
          });
        });
      });
    });
  }

  function boot() {
    initReveals();
    initFinder();
    initReviewForm();
    initFaqSingleOpen();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
